import {paramsFromLocation} from '@yandex-delivery/utils/url'
import {compose, createStore} from 'redux'

import {rootReducer} from './reducer'

const composeEnhancers =
  (process.env.NODE_ENV === 'development' || paramsFromLocation().debug) &&
  typeof window === 'object' &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        // Specify extension’s options like name, actionsBlacklist, actionsCreators,
        // serialize...
      })
    : compose

export const store = createStore(rootReducer, {}, composeEnhancers())
